import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouteReuseStrategy } from "@angular/router";
import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { PipesModule } from "./pipes/pipes.module";
import { ModalPicturesComponent } from "./components/modal-pictures/modal-pictures.component";
import { ModalSynchroComponent } from "./components/modal-synchro/modal-synchro.component";
import { LoginActivate } from "./services/login-activate.service";
import { LaunchNavigator } from "@awesome-cordova-plugins/launch-navigator/ngx";
import { KeepAwakeWeb } from "@capacitor-community/keep-awake/dist/esm/web";
import { ModalSosComponent } from "./components/modal-sos/modal-sos.component";
import { ComponentsModule } from "./components/components.module";
import { ModalSurveyComponent } from "./components/modal-survey/modal-survey.component";

@NgModule({
  declarations: [
    AppComponent,
    ModalPicturesComponent,
    ModalSynchroComponent,
    ModalSosComponent,
    ModalSurveyComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot({
      mode: "ios",
      animated: true,
      swipeBackEnabled: false,
      innerHTMLTemplatesEnabled: true,
      scrollAssist: false,
      scrollPadding: false,
    }),
    AppRoutingModule,
    PipesModule,
    ComponentsModule,
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    LoginActivate,
    LaunchNavigator,
    KeepAwakeWeb,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
